import styled from 'styled-components';
import { Layout } from 'antd';
import { createElement, Component, Props as ReactProps } from 'react';
import { DependencyProps } from '../../core/dependency';
import { StateProps } from '../../core/state';
import { LocationProps } from '../../core/location';

type Props = ReactProps<HTMLElement> & DependencyProps & StateProps & LocationProps;

const StyledLayout = styled(Layout)`
  width: 100%;
  height: 100%;
`;

const StyledText = styled.div`
  margin-bottom: 16px;
`;

class NotFoundRoute extends Component<Props, {}> {
  constructor(props: Props) {
    super(props);
  }

  public render() {
    return (
      <StyledLayout>
        <StyledText>
          Not Found
        </StyledText>
      </StyledLayout>
    );
  }
}

export default NotFoundRoute;
